<div class="row">
    <ul class="search-tools pl-2">

        <li>
            <div class="icon-bar">  <!-- 4/29/26 moved icon bar before search input for better mobile screen appearance-->
                <div class="action-item-container">

                    <!-- Asset Search -->
                    <div class="action-item">
                        <a href="#" title="{{'Search-tool.icon.assetsearch'|translate}}" id='AssetSearch'
                            [attr.aria-label]="''+'Search-tool.icon.assetsearch'|translate" 
                            [ngClass]="{ 'i-inactive': !isAssetSearchtEnabled, 'i-active': isAssetSearchtEnabled }"
                            (click)="AssetSearch('AssetSearch')" data-mainPageTabbing="yes">
                            <mat-icon svgIcon="find_in_page" [ngClass]="{ 'i-inactive': !isAssetSearchtEnabled, 'i-active': isAssetSearchtEnabled }"></mat-icon>
                        </a>
                    </div>

                    <!-- Address Search-->
                    <div class="action-item">
                        <a href="#" title="{{'Search-tool.icon.addressearch'|translate}}" id='AddressSearch'
                            [attr.aria-label]="''+'Search-tool.icon.addressearch'|translate" data-mainPageTabbing="yes"
                            [ngClass]="{ 'i-inactive': !isAddressSearchEnabled, 'i-active': isAddressSearchEnabled }"

                            (click)="AddressSearch('AddressSearch')">
                            <mat-icon svgIcon="home_pin" [ngClass]="{ 'i-inactive': !isAddressSearchEnabled, 'i-active': isAddressSearchEnabled }"></mat-icon>
                        </a>
                    </div>

                    <!-- Proximity Search     4/29/26 not useful-->
                    <!-- <div class="action-item">
                        <a href="#" title="{{'Search-tool.icon.proximitysearch'|translate}}"
                            (click)="ProximitySearch('ProximitySearch')" id='ProximitySearch'
                            [ngClass]="{ 'i-inactive': !isProximitySearchEnabled, 'i-active': isProximitySearchEnabled }"
                            [attr.aria-label]="''+'Search-tool.icon.proximitysearch'|translate" data-mainPageTabbing="yes"
                            *ngIf="currentUser.soultionTiers[0][0].proximity_Assets">
                            <mat-icon svgIcon="location_searching" [ngClass]="{ 'i-inactive': !isProximitySearchEnabled, 'i-active': isProximitySearchEnabled }"></mat-icon>
                        </a>
                    </div> -->

                </div>
            </div>
        </li>

        <li class="mr-3">
            <div id='searchWidgetDiv' aria-label="Search Widget"></div>
        </li>
        
    </ul>
</div>